import fetcher from '../../modules/ajio-fetch';
import {
  fetchGetJSONReqOpts,
  fetchGetJSONResHandler,
  askUserLocation
} from '../../modules/ajio-fetch/utils';
import properties from '../../modules/ajio-util/properties';
import {
  readCookie,
  createCookie,
  readClusterCookie,
  readCohortValueCookie
} from '../../components/common/Cookie';
import { postalCodeFetch } from '../../myaccount/actions/addressBook';
import { showModal, hideModal, updateModal } from '../modal';
import { addLocaleInfoToCleverTap } from '../../modules/ajio-util/cleverTap/eventUtils';
import { getBannerDetailsRuntime, getRuntimeBanners } from '../homeData.js';
import { updateRuntimeData } from '../../utils/banner.js';
import { getRuntimeBannersFlag } from '../../Flags/selectors.js';
import { getFeatureVariant, getVariant } from '../../refresh/organism/ABFeature/Feature';
import { setCookie } from '../../refresh/utils/cookie';
import { showLoader, hideLoader } from '../shared/loader';
import { getAmplitudeVariantPayload } from '../../utils/amplitudeCommon';

export function getShopPageClientApiEndpoint(urlParameter = '') {
  return {
    API: `/api/shop/${urlParameter}`
  };
}
export function updateBannerState(payload = {}) {
  return (dispatch, getState) => {
    const state = getState();
    const {
      bannerInfo: { isRuntimeBannerPage } = {},
      metaData: { name } = {},
      flags: {
        enableClusterFeatureHome,
        earlyAccessEnabled,
        jioAdsSpecs: { sdkParams = {} } = {},
        jioAdsLandingPagesExperiment = '',
        landingPagesExperiments = []
      } = {}
    } = state;
    const enableUniversalCohortFlow = getAmplitudeVariantPayload('enableUniversalCohortFlow', state, false);

    if (typeof window !== 'undefined') {
      const jioSDKvalues = window.JioAds?.getRequestParams?.();
      const sdkParamsList = Object.keys(sdkParams);
      sdkParamsList.forEach(sdkParamKey => {
        if (jioSDKvalues?.[sdkParamKey] !== undefined) {
          createCookie(sdkParamKey, jioSDKvalues?.[sdkParamKey], 1);
        }
      });
    }
    if (!isRuntimeBannerPage) {
      dispatch({
        type: 'UPDATE_BANNER_BASED_ON_LOCALE',
        payload
      });
    } else {
      const { city, state, zone, pincodeGroup = '', customerType } = payload;
      if (
        city ||
        state ||
        zone ||
        (typeof window !== 'undefined' && window.pageType === 'LANDINGPAGE')
      ) {
        createCookie('CT', city, 1);
        createCookie('ST', state, 1);
        createCookie('ZN', zone, 1);
        createCookie('PG', pincodeGroup, 1);
        // since this is coming for the banner, we need cms banner in case this is new banners
        const userGroup = readCohortValueCookie('userCohortValues', name, 'cms', enableUniversalCohortFlow);
        const flag = enableClusterFeatureHome === 'ON';
        // if (flag) {
        //   userGroup = readClusterCookie('cluster', name);
        // }
        const { location: { search = '' } = {} } = window || {};

        const earlyAccessFlag = earlyAccessEnabled === 'ON';
        let isHomePage = false;
        const path = window?.location?.pathname || '';
        if (path === '/' || path.indexOf('/shop/') >= 0) {
          isHomePage = true;
        }

        // do nothing if it's CMS preview
        if (search.includes('isPreview')) {
          return;
        }

        dispatch(
          getRuntimeBanners({
            city,
            state,
            zone,
            pincodeGroup,
            customerType,
            userGroup,
            enableClusterFeatureHome: flag,
            enableEarlyAccessFlag: isHomePage ? true : earlyAccessFlag,
            storeName: name
          })
        );
      }
    }
  };
}
export function savedCustomerTypeData(payload = {}) {
  return async (dispatch, getState) => {
    const { API = '' } = getShopPageClientApiEndpoint(`fetchPostalCodeDetails`);
    const {pincode = ''} = payload;
    const requestData = JSON.stringify({ pincode });
    fetcher(
      API,
      fetchGetJSONReqOpts({
        body: requestData,
        headers: { 'content-type': 'application/json' },
        method: 'POST'
      })
    )
      .then(fetchGetJSONResHandler)
      .then(response => {
        const pincodeGrp = response?.pincodeGroup;
        dispatch(updateBannerState({...payload, pincodeGroup: pincodeGrp }))
      })
      .catch(error => {
        console.log(error);
      });
  };
}
// Cross-platform function to calculate byte size
export function getByteSize(obj) {
  const str = JSON.stringify(obj)
  if (typeof TextEncoder !== "undefined") {
      // ✅ Browser & Modern Node.js
      return new TextEncoder().encode(str).length;
  } else if (typeof Buffer !== "undefined") {
      // ✅ Node.js 10+ (Legacy support)
      return Buffer.byteLength(str, "utf8");
  } else {
      // ❌ Fallback (Very unlikely case)
     console.log("Your environment does not support TextEncoder or Buffer.");
  }
}
export async function getLocalStorageLocaleData() {
  const lastSaveDate = localStorage.getItem('lastModalClose');
  if (!lastSaveDate) {
    return Promise.resolve(-1); // No localStorage is set since user visit first Time
  }
  const moment = await import(/* webpackChunkName: "static/chunk/moment" */ 'moment').then(
    ({ default: moment }) => moment
  );
  // const { loadMoment } = await import("../../utils/moment.js");
  // const moment = await loadMoment();
  return moment().diff(lastSaveDate, 'days');
}
export function getLocaleData(customerId, callback, fetchDefaultAddress = false) {
  const { API = '' } = getShopPageClientApiEndpoint(`customerType`);
  const postalCode = readCookie('PC') || '';
  let sendCohortValue = false;
  if (getFeatureVariant('cohortValues') !== '0') {
    sendCohortValue = true;
  }
  return (dispatch, getState) =>
    fetcher(
      API,
      fetchGetJSONReqOpts({
        body: JSON.stringify({ customerId, sendCohortValue, fetchDefaultAddress }),
        headers: { 'content-type': 'application/json' },
        method: 'POST',
        credentials: 'include'
      })
    )
      .then(fetchGetJSONResHandler)
      .then(response => {
        const {
          pincode = '',
          userSegmentIdSet = '',
          userCohortValue = '',
          customerType = '',
          city = '',
          zone = ''
        } = response;
        if (userSegmentIdSet) {
          setCookie('cohortSegment', userSegmentIdSet.toString());
        }
        if (userCohortValue) {
          // here we will check if the cohort values are withing 
          // If the value is within 1KB then only we will add the cohort
          if(getByteSize(userCohortValue) <= 1024){
            setCookie('userCohortValues', JSON.stringify(userCohortValue));
          }
         
        }
        if (customerType) {
          setCookie('customerType', customerType);
        }
        if (city) {
          setCookie('CT', city);
        }
        if (zone) {
          setCookie('ZN', zone);
        }
        if (pincode.length) {
          sessionStorage.setItem('customerTypeData', JSON.stringify(response));
          localStorage.setItem('customerTypeData', JSON.stringify(response));
          setCookie('pincode', pincode);
          setCookie('PC', pincode);
          addLocaleInfoToCleverTap(response);
          if (fetchDefaultAddress) {
            callback(response);
          } else {
            updateBannerState(response)(dispatch, getState);
            callback();
          }
        } else {
          postalCode.length ? dispatch(postalCodeFetch({ postalCode }, callback)) : callback();
        }
      })
      .catch(() => {
        postalCode.length ? dispatch(postalCodeFetch({ postalCode }, callback)) : callback();
      });
}

export function userAllowLocationForLocale(dispatch) {
  return GeolocationPosition => {
    const { coords: { latitude = '', longitude = '' } = {} } = GeolocationPosition;
    const { API = '' } = getShopPageClientApiEndpoint(`userGeoLocation`);
    fetcher(
      API,
      fetchGetJSONReqOpts({
        body: JSON.stringify({ latitude, longitude }),
        headers: { 'content-type': 'application/json' },
        method: 'POST'
      })
    )
      .then(fetchGetJSONResHandler)
      .then(response => {
        const { invalidpostalcode = true } = response;
        if (!invalidpostalcode) {
          updateBannerState(response)(dispatch);
        }
      })
      .catch(error => {
        console.log(error);
      });
  };
}

export function userAllowedLocationForRuntimeLocale(optionalObject, cb) {
  return (dispatch, getState) => {
    const { API = '' } = getShopPageClientApiEndpoint(`runtimeUserGeoLocation`);

    const defaultObject = {
      enableHighAccuracy: true,
      timeout: 5000,
      maximumAge: 0,
      ...optionalObject
    };

    const geolocationTimeout = setTimeout(() => {
      console.log('Geolocation timeout - possibly blocked or disabled.');
      dispatch(hideModal('locale-banner-popup'));
    }, 5000);

    if (!navigator.geolocation) {
      console.log('Geolocation is not supported by your browser');
    } else {
      navigator.geolocation.getCurrentPosition(
        GeolocationPosition => {
          clearTimeout(geolocationTimeout);
          const { coords: { latitude = '', longitude = '' } = {} } = GeolocationPosition;
          fetcher(
            API,
            fetchGetJSONReqOpts({
              body: JSON.stringify({ latitude, longitude }),
              headers: { 'content-type': 'application/json' },
              method: 'POST'
            })
          )
            .then(fetchGetJSONResHandler)
            .then(response => {
              if (typeof cb === 'function') {
                cb(response);
              } else {
                updateBannerState(response)(dispatch, getState);
              }
            })
            .catch(error => {
              console.log(error);
            });
        },
        error => {
          clearTimeout(geolocationTimeout);
          dispatch(hideModal('locale-banner-popup'));
        },
        defaultObject
      );
    }
  };
}

export function userAllowedLocationForLocale(optionalObject) {
  return (dispatch, getState) => {
    const { API = '' } = getShopPageClientApiEndpoint(`userGeoLocation`);

    const defaultObject = {
      enableHighAccuracy: true,
      timeout: 5000,
      maximumAge: 0,
      ...optionalObject
    };

    if (!navigator.geolocation) {
      console.log('Geolocation is not supported by your browser');
    } else {
      navigator.geolocation.getCurrentPosition(
        GeolocationPosition => {
          const { coords: { latitude = '', longitude = '' } = {} } = GeolocationPosition;
          fetcher(
            API,
            fetchGetJSONReqOpts({
              body: JSON.stringify({ latitude, longitude }),
              headers: { 'content-type': 'application/json' },
              method: 'POST'
            })
          )
            .then(fetchGetJSONResHandler)
            .then(response => {
              const { invalidpostalcode = true } = response;
              if (!invalidpostalcode) {
                updateBannerState(response)(dispatch, getState);
              }
            })
            .catch(error => {
              console.log(error);
            });
        },
        () => {
          dispatch(hideModal('locale-banner-popup'));
        },
        defaultObject
      );
    }
  };
}

export function setMyJioLocationData(locationData) {
  return (dispatch, getState) => {
    const { API = '' } = getShopPageClientApiEndpoint(`runtimeUserGeoLocation`);
    const requestData = JSON.stringify(locationData);
    setCookie('myJioLocationData', requestData);
    fetcher(
      API,
      fetchGetJSONReqOpts({
        body: requestData,
        headers: { 'content-type': 'application/json' },
        method: 'POST'
      })
    )
      .then(fetchGetJSONResHandler)
      .then(response => {
        updateBannerState(response)(dispatch, getState);
      })
      .catch(error => {
        console.log(error);
      });
  };
}

export function fetchPostalCodeDetails(pincode, cb) {
  return (dispatch, getState) => {
    dispatch(showLoader('address-loader'));
    const { API = '' } = getShopPageClientApiEndpoint(`fetchPostalCodeDetails`);
    const requestData = JSON.stringify({ pincode });
    return fetcher(
      API,
      fetchGetJSONReqOpts({
        body: requestData,
        headers: { 'content-type': 'application/json' },
        method: 'POST'
      })
    )
      .then(fetchGetJSONResHandler)
      .then(response => {
        dispatch(hideLoader("address-loader"));
        if (typeof cb === 'function') {
          cb(response);
        }
        return response;
      })
      .catch(error => {
        dispatch(hideLoader("address-loader"));
        console.log(error);
      });
  };
}
